import { useSelector } from 'react-redux';
import { ReduxState } from '../../store/types';
import { useMemo } from 'react';
import { convertCurrentDateToUserTimeZone } from '../../views/PortalUsers/utils';

export const useStatusSectionData = () => {
    const { timeZonesList, languagesList } = useSelector(
        (state: ReduxState) => state.generic,
    );

    const iTimeZone = useSelector(
        (state: ReduxState) => state.myProfile?.customer?.iTimeZone,
    );

    const minDateForActivation = useMemo(() => {
        const tzName = timeZonesList.find((e) => e.i_time_zone === iTimeZone)
            ?.time_zone_name;
        return convertCurrentDateToUserTimeZone(tzName);
    }, [timeZonesList, iTimeZone]);

    const userDateFormat = useSelector<ReduxState, string>(
        (state) =>
            state.generic.globalCustomerInfo?.customer_info?.out_date_format ||
            '',
    );

    return {
        timeZonesList,
        iTimeZone,
        minDateForActivation,
        userDateFormat,
        languagesList,
    };
};
